import { FormControl, FormLabel, MenuItem, Select } from "@mui/material";
import React from "react";

export const ALL_DEVICE_TYPE = "all";

export default function DeviceTypeFilter({
  value,
  onChange,
  options,
}: {
  value?: string;
  onChange: (value: string) => void;
  options: string[];
}) {
  return (
    <FormControl sx={{ minWidth: 180 }}>
      <FormLabel id="device-type-filter">Filter Devices</FormLabel>
      <Select
        labelId="device-type-filter"
        value={value}
        onChange={(event) => onChange(event.target.value)}
      >
        <MenuItem value={ALL_DEVICE_TYPE}>--</MenuItem>
        {options.map((option) => (
          <MenuItem value={option}>{option}</MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
